import React from 'react';

import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';


import { TileContainerBasic } from '@src/components/TileContainerBasic';
import { imageOrDefault } from '@src/utils/defaultImage';

import styles from './productUpdates.scss';

import global from '@src/css/global.scss';

export const ProductUpdatesCardRow = ({ productArticles }) => (
    <Row
        id="components-products-newsandupdates-compents-cardrow-row"
        className={`${global.basicHomePagePromoCards_container} ${styles.featuredArticles_container}`}
    >
        {
            productArticles
            && productArticles.map((article) => (
                <TileContainerBasic
                    key={`product-article-${article.id}`}
                    urlPrefix="/products/product-news-and-updates/"
                    {...article}
                    image={imageOrDefault(article.image)}
                />
            ))
        }
    </Row >
);

ProductUpdatesCardRow.propTypes = {
    productArticles: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
    })).isRequired,
};
